export default __webpack_public_path__ + "static/media/nagakawa.95bd8b2c.png";